import React, { useEffect, useState } from 'react'
import { Box, Paper, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import ButtonComponent from './ButtonComponent'
import ImageComponent from './ImageComponent'
import MediaCropperComponent from './MediaCropperComponent'
import VideoComponent from './VideoComponent'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minWidth: '300px',
    width: '100%',
  },
  imgDesc: {
    padding: theme.spacing(2),
  },
  image: {
    height: 'auto',
    width: '100%',
    objectFit: 'cover',
    borderTopLeftRadius: '1%',
    borderTopRightRadius: '1%',
  },
  actionItem: {
    marginLeft: theme.spacing(1),
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}))

type IProps = {
  file?: any
  temporaryMediaFile?: any
  onlyUploadButton?: boolean
  setMediaFile?: (file: string | undefined, fileId?: string, type?: string) => void // not called on Upload
  allowVideoUpload?: boolean
  allowImageUpload?: boolean
  loading?: boolean
  isVideo?: boolean
  initialAspectRatio?: number
  aspectRatio?: number
  minCropBoxHeight?: number
  minCropBoxWidth?: number
  cropBoxResizable?: boolean
}

const MediaUploadComponent: React.FC<IProps> = (props) => {
  const classes = useStyles()

  const [cropper, setCropper] = useState<any>()
  const [file, setFile] = useState<string | undefined>()
  const [isVideo, setIsVideo] = useState<boolean>(false)
  const [preview, setPreview] = useState<string | undefined>()
  const [actualImage, setActualImage] = useState<string | undefined>(undefined)
  // TODO const [innerLoading, setInnerLoading] = useState(false)
  const innerLoading = false

  const temporaryMediaFile: any | undefined = props.temporaryMediaFile

  const getCropData = () => {
    if (typeof cropper !== 'undefined') {
      const img = cropper.getCroppedCanvas().toDataURL()
      props.setMediaFile && props.setMediaFile(img)
      setPreview(img)
      setFile(undefined)
    }
  }

  const onChangeImage = (img: string, file: File | undefined) => {
    setFile(img)
  }

  const onChangeVideo = (video: string, file: File | undefined) => {
    setFile(video)
    props.setMediaFile && props.setMediaFile(video)
    setPreview(video)
    setIsVideo(true)
    setFile(undefined)
  }

  const handleCropped = (instance: Cropper) => {
    setCropper(instance)
  }

  const deleteImage = () => {
    setFile(undefined)
    setPreview(undefined)
    setIsVideo(false)
    setActualImage(undefined)
    props.setMediaFile && props.setMediaFile(undefined)
  }

  useEffect(() => {
    temporaryMediaFile && props.setMediaFile && props.setMediaFile(temporaryMediaFile.directLink, temporaryMediaFile.mediaFileId, temporaryMediaFile.mimeType)
    temporaryMediaFile && (temporaryMediaFile.mimeType.includes('video') ? setIsVideo(true) : setIsVideo(false))
  }, [temporaryMediaFile])

  useEffect(() => {
    setActualImage(props.file ? props.file as string : undefined)
    setFile(undefined)
    setPreview(undefined)
  }, [props.file])

  return (
    <>
      {props.onlyUploadButton && (
        <MediaCropperComponent
          mediaFile={file}
          preview={preview}
          getCropData={getCropData}
          handleCropped={handleCropped}
          deleteImage={deleteImage}
          onChangeImage={onChangeImage}
          onChangeVideo={onChangeVideo}
          allowVideoUpload={props.allowVideoUpload}
          allowImageUpload={props.allowImageUpload}
          minCropBoxHeight={props.minCropBoxHeight}
          minCropBoxWidth={props.minCropBoxWidth}
          cropBoxResizable={props.cropBoxResizable}
          loading={innerLoading || props.loading}
          initialAspectRatio={props.initialAspectRatio}
          aspectRatio={props.aspectRatio}
        />)}
      {!props.onlyUploadButton && (
        <Paper className={classes.root}>
          {!file && !(props.isVideo || isVideo) && (
            <Box display='flex' justifyContent='center'>
              <ImageComponent
                className={classes.image}
                src={preview || actualImage}
              />
            </Box>)}
          {!file && (props.isVideo || isVideo) && (
            <Box display='flex' justifyContent='center'>
              <VideoComponent
                src={preview || actualImage}
                fallbackThumb='/src/shared/assets/images/icon-img-placeholder.svg'
                height={450}
                width='100%'
                controls
              />
            </Box>)}
          <Box className={classes.imgDesc}>
            <Box>
              <MediaCropperComponent
                mediaFile={file}
                getCropData={getCropData}
                handleCropped={handleCropped}
                deleteImage={deleteImage}
                onChangeImage={onChangeImage}
                onChangeVideo={onChangeVideo}
                allowVideoUpload={props.allowVideoUpload}
                allowImageUpload={props.allowImageUpload}
                loading={innerLoading || props.loading}
              />
              <ButtonComponent
                className={classes.actionItem}
                text='Löschen'
                color='info'
                variant='outlined'
                onClick={deleteImage}
              />
            </Box>
          </Box>
        </Paper>)}
    </>
  )
}

export default MediaUploadComponent
